import React from 'react';
import {stepStates} from "../../../services/helpers";

function StepsIndication({stepsState}) {

    const bullets = stepsState.map((item, i) => {
        return (
            <div key={i} className={`${(item === stepStates.inactive || item === stepStates.closed) ? 'ct-step__indication-empty' : 'ct-step__indication-filled' }`}>{ i + 1}</div>
        )
    });

    return (
        <div className="ct-step__indication">
            {bullets}
        </div>
    );
}

export default StepsIndication;
